import { FEATURE_NAMES } from '../../loaders/features/features';
export var FEATURE_NAME = FEATURE_NAMES.sessionTrace;
export var BST_RESOURCE = 'bstResource';
export var RESOURCE = 'resource';
export var START = '-start';
export var END = '-end';
export var FN_START = 'fn' + START;
export var FN_END = 'fn' + END;
export var PUSH_STATE = 'pushState';
export var MAX_NODES_PER_HARVEST = 1000;